export const BusinessGroupsPermissions = {
    OpenBusinessGroupsTree: {
        permissionsId: '561efbca-e0dc-4c97-58ec-08d96ae23e90',
        permissionsName: 'Open Business Groups Tree',
        componentsId: null,
        components: null
    },
    AddRecordCard: {
        permissionsId: '7b0ce0bf-df94-4911-58ed-08d96ae23e90',
        permissionsName: 'Add Record Card',
        componentsId: null,
        components: null
    },
    DeleteRecordCard: {
        permissionsId: 'fee79db6-99ed-4031-e7c9-08d96ae283eb',
        permissionsName: 'Delete Record Card',
        componentsId: null,
        components: null
    },
    EditRecordCard: {
        permissionsId: '02035469-de38-4524-e7ca-08d96ae283eb',
        permissionsName: 'Edit Record Card',
        componentsId: null,
        components: null
    }

};
